const toSentence = function (array) {
  const wordsConnector = ", "
  const lastWordConnector = " e "

  let sentence

  switch(array.length) {
    case 0:
      sentence = ""
      break
    case 1:
      sentence = array[0]
      break
    case 2:
      sentence = array[0] + lastWordConnector + array[1]
      break
    default:
      sentence = array.slice(0, -1).join(wordsConnector) + lastWordConnector + array[array.length - 1]
      break
  }

  return sentence
}

export {
  toSentence
}
